import { Pipe, PipeTransform } from '@angular/core';
import { Fce } from '../fce';

@Pipe({ name: 'bool' })
export class BoolPipe implements PipeTransform {
    constructor() { }
    transform(bool) {
        return Fce.intToBoolean(bool)
    }
} 
